import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getSpeed = (speedId: number | undefined): Promise<IGetSpeed> => {
  return axiosDefaultApi.get(`/api/Speeds/GetSpeedViaID/${speedId}`);
};

type QueryFnType = typeof getSpeed;

type UseGetSpeedOptions = {
  speedId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetSpeed = ({ speedId , config }: UseGetSpeedOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getSpeed_${speedId}`],
    queryFn: () => getSpeed(speedId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Ταχύτητας Γραμμής.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};